import { put, takeLatest } from 'redux-saga/effects';
import { setCarrierInfo } from '../reducers/carrierInfoSlice';

export function* workerCarrierInfoSaga({ payload }) {
    yield put(setCarrierInfo(payload))
}

export default function* carrierInfoSaga() {
    yield takeLatest("carrierInfo/getCarrierInfo", workerCarrierInfoSaga);
}